import { useState } from "react";
import {
  IconButton,
  Typography,
  Checkbox,
  Box,
  Card,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemButton
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";
export const stringToLocale = (dateString) => {
  const options = {
    year: "numeric",
    month: "long"
  };

  const date = new Date(dateString);
  if (isNaN(date)) {
    return "Invalid Date";
  }
  return date.toLocaleDateString(navigator.language, options);
};

const ExperienceCard = ({
  workHistory,
  unknownCompany,
  companyItemHandlePressed,
  projectItemHandlePressed,
  noCompanyProjectItemHandlePressed,
  allNoCompanyProjectItemHandlePressed
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.ResumeBuilder || {};
  const {
    TEXT_USER_EXPERIENCE_INFO = English.ResumeBuilder.TEXT_USER_EXPERIENCE_INFO,
    TEXT_NO_COMPANY = English.ResumeBuilder.TEXT_NO_COMPANY,
    TEXT_NO_EXPERIENCE_TO_PROFILE = English.ResumeBuilder.TEXT_NO_EXPERIENCE_TO_PROFILE
  } = LanguageData || {};

  return (
    <Card className="pagelist-content" sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{TEXT_USER_EXPERIENCE_INFO}</Typography>
        <IconButton color="primary" onClick={() => setIsExpanded((prev) => !prev)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      {isExpanded && (
        <List disablePadding>
          <Stack spacing={1} pt={1}>
            {workHistory?.length > 0 ? (
              workHistory.map((company, index) => (
                <Company
                  key={index}
                  company={company}
                  index={index}
                  itemType={"KnownCompanies"}
                  companyItemHandlePressed={companyItemHandlePressed}
                  projectItemHandlePressed={projectItemHandlePressed}
                />
              ))
            ) : (
              <Typography>{TEXT_NO_EXPERIENCE_TO_PROFILE}</Typography>
            )}
            {unknownCompany?.length > 0 && (
              <>
                <Stack
                  p={1}
                  pr={2}
                  justifyContent="space-between"
                  direction="row"
                  alignItems="center">
                  <Typography variant="h6">{TEXT_NO_COMPANY}</Typography>
                  <Checkbox
                    edge="end"
                    onChange={allNoCompanyProjectItemHandlePressed}
                    checked={unknownCompany.some((project) => project.isSelected)}
                  />
                </Stack>

                {unknownCompany.map((project, index) => (
                  <Project
                    key={index}
                    projectIndex={index}
                    itemType="UnknownCompanies"
                    company={project}
                    project={project}
                    projectName={project}
                    projectItemHandlePressed={noCompanyProjectItemHandlePressed}
                    companyIndex={0}
                  />
                ))}
              </>
            )}
          </Stack>
        </List>
      )}
    </Card>
  );
};

export default ExperienceCard;

const Company = ({ company, index, companyItemHandlePressed, projectItemHandlePressed }) => {
  return (
    <Card
      key={index.toString()}
      className="pagelist-content"
      sx={{ marginTop: "0px", padding: 0, cursor: "pointer" }}>
      <ListItem
        key={index.toString()}
        alignItems="flex-start"
        sx={{ m: 0, p: 0 }}
        secondaryAction={
          <Checkbox
            edge="end"
            onChange={() => companyItemHandlePressed(company, index)}
            checked={company.isSelected}
          />
        }>
        <ListItemButton
          onClick={() => companyItemHandlePressed(company, index)}
          alignItems="flex-start">
          <ListItemText
            sx={{ m: 0, alignItems: "flex-start" }}
            primary={<Typography variant="body1">{company?.companyName}</Typography>}
            secondary={
              <Box>
                <Stack>
                  <Typography variant="body2">{company?.roleName}</Typography>
                  <Typography variant="body2">
                    {company?.startDate === null && company?.endDate === null
                      ? ""
                      : `${stringToLocale(company.startDate)} - ${
                          company?.currentCompany || company?.endDate === null
                            ? "Present"
                            : stringToLocale(company.endDate)
                        }`}
                  </Typography>
                </Stack>
              </Box>
            }
          />
        </ListItemButton>
      </ListItem>
      <Box sx={{ p: company?.experience?.length == 0 ? 0 : 2, pt: 0 }}>
        <Stack spacing={1}>
          {company?.experience
            ?.sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
            .map((project, idx) => (
              <Project
                key={idx}
                projectIndex={idx}
                project={project}
                company={company}
                ischecked={project.isSelected}
                projectItemHandlePressed={projectItemHandlePressed}
                companyIndex={index}
              />
            ))}
        </Stack>
      </Box>
    </Card>
  );
};

const Project = ({ project, projectItemHandlePressed, companyIndex, projectIndex }) => {
  return (
    <Card
      key={projectIndex.toString()}
      className="pagelist-content"
      sx={{ marginTop: "0px", padding: 0, cursor: "pointer", backgroundColor: "#f2f2f2" }}>
      <ListItem
        key={projectIndex.toString()}
        alignItems="flex-start"
        sx={{ m: 0, p: 0 }}
        secondaryAction={
          <Checkbox
            edge="end"
            onChange={() =>
              projectItemHandlePressed({
                item: project,
                index: companyIndex,
                projectIndex: projectIndex
              })
            }
            checked={project.isSelected}
          />
        }>
        <ListItemButton
          onClick={() =>
            projectItemHandlePressed({
              item: project,
              index: companyIndex,
              projectIndex: projectIndex
            })
          }
          alignItems="flex-start"
          sx={{ m: 0 }}>
          <ListItemText
            sx={{ m: 0, alignItems: "flex-start" }}
            primary={<Typography variant="body1">{project?.projectName}</Typography>}
            secondary={
              <Box>
                <Stack>
                  <Typography variant="body2">{project?.siteName}</Typography>
                  {project?.startDate && (
                    <Typography variant="body2">
                      {stringToLocale(project.startDate)} -{" "}
                      {project?.present
                        ? "Present"
                        : project.endDate && stringToLocale(project.endDate)}
                    </Typography>
                  )}
                </Stack>
              </Box>
            }
          />
        </ListItemButton>
      </ListItem>
    </Card>
  );
};
